import React, { useState } from "react";
import "./App.css";
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { Products } from './components/Products';
import { ProductDetail } from './components/ProductDetail';
import { Services } from './components/Services';
import { Industries } from './components/Industries';
import { About } from './components/About';
import { Contact } from './components/Contact';
import { Footer } from './components/Footer';
import { Toaster } from './components/ui/sonner';

function App() {
  const [currentView, setCurrentView] = useState('home');
  const [selectedProductId, setSelectedProductId] = useState(null);

  const handleProductSelect = (productId) => {
    setSelectedProductId(productId);
    setCurrentView('product-detail');
  };

  const handleBackToHome = () => {
    setCurrentView('home');
    setSelectedProductId(null);
    // Scroll to products section after a brief delay
    setTimeout(() => {
      const productsElement = document.getElementById('products');
      if (productsElement) {
        productsElement.scrollIntoView({ behavior: 'smooth' });
      }
    }, 100);
  };

  if (currentView === 'product-detail') {
    return (
      <div className="App">
        <ProductDetail 
          productId={selectedProductId} 
          onBack={handleBackToHome}
        />
        <Toaster />
      </div>
    );
  }

  return (
    <div className="App">
      <Header />
      <Hero />
      <Products onProductSelect={handleProductSelect} />
      <Services />
      <Industries />
      <About />
      <Contact />
      <Footer />
      <Toaster />
    </div>
  );
}

export default App;